export default __webpack_public_path__ + "content/media/1.90a2a9fe.jpg";